/**
 * State of user session timeout monitoring
 */
export enum SessionTimeoutStateEnum {
  /**
   * Session is active with plenty of time remaining
   */
  ACTIVE = 'active',

  /**
   * Session will expire soon (within warning threshold)
   */
  WARNING = 'warning',

  /**
   * Session is about to expire (within critical threshold)
   */
  CRITICAL = 'critical',

  /**
   * Session has expired
   */
  EXPIRED = 'expired',
}
